import React, { memo } from 'react';
import styled from 'styled-components';

import Skeleton from '@pedidosya/web-fenix/atoms/Skeleton';

const Container = styled.div`
  * {
    box-sizing: border-box;
  }
  padding: ${({ theme }) => theme.spacing(8)};
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.spacing(12, 12, 0, 0)};
  display: flex;
  flex-direction: column;
`;

const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ContainerSubheader = styled.div`
  background: ${({ theme }) => theme.colors.french_gray_2};
  border-radius: ${({ theme }) => theme.commons.card.borderRadius};
  padding: ${({ theme }) => theme.spacing(12)};
  margin-top: ${({ theme }) => theme.spacing(8)};
  height: 124px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const MobileHeaderShimmer = () => (
  <Container aria-busy="true">
    <ContainerHeader>
      <Skeleton height="8" shape="square" width="36" />
      <Skeleton height="12" shape="square" width="30" />
    </ContainerHeader>
    <ContainerSubheader>
      <Skeleton height="8" shape="square" width="50" />
      <Skeleton height="8" shape="square" width="36" />
    </ContainerSubheader>
  </Container>
);

export default memo(MobileHeaderShimmer);
